import { render, staticRenderFns } from "./AuctionSubmitModal.vue?vue&type=template&id=3b0b36f5"
import script from "./AuctionSubmitModal.vue?vue&type=script&lang=js"
export * from "./AuctionSubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports